module.exports = __webpack_public_path__ + "img/icon_check.1feb5427.svg";